interface IStringMap {
  [key: string]: string;
}

interface IOrderedLabel {
  label: string;
  order: number;
}
interface IOrderedMap {
  [key: string]: IOrderedLabel;
}

interface IOptions {
  label: string;
  value: any;
}

const K12_TYPE_MAP: IStringMap = {

};

export const TYPE_CODE_K12 = 1;
export const TYPE_CODE_OTHER_ED = 9;
export const TYPE_CODE_OTHER = 7;

export const AI_STATUS_ACTIVE = '2';
export const AI_STATUS_INACTIVE = '1';


const AI_STATUS_MAP: IStringMap = {
  '2': 'Active',
  '1': 'Inactive'
};

const ORG_TYPE_MAP: IStringMap = {
  "0": "NO ANSWER",
  "1": "Bureau of Indian Affairs School",
  "2": "Catholic School",
  "3": "Catholic Diocesan Office",
  "4": "Archdiocese",
  "5": "Department of Defense School",
  "6": "DOD District",
  "7": "DOD Area",
  "8": "DOD School System",
  "9": "DOD Education Agency",
  "10": "Correctional Facility",
  "11": "Private School, Non-Religious",
  "12": "Home School Association or Program",
  "13": "Home School Association",
  "14": "Other",
  "15": "US Public School",
  "16": "State Operated School",
  "17": "Main District",
  "18": "Sub District",
  "19": "Regular District",
  "20": "Regional Education Agency",
  "21": "Non-Operating District",
  "22": "Supervisory Union",
  "23": "District In Supervisory Union",
  "24": "Intermediate Unit",
  "25": "Special Education District",
  "26": "State Department of School Education",
  "27": "Public College",
  "28": "County College System Office",
  "29": "Public College System Office",
  "30": "Vocational Education District",
  "31": "State Department of Postsecondary Education",
  "32": "Federally-Run College",
  "33": "Private College",
  "34": "Private College Family",
  "35": "International School",
  "36": "Group of International Schools",
  "37": "International Postsecondary Institution",
  "38": "Group of International Postsecondary Institutions",
  "39": "Education Initiative",
  "40": "Consortium",
  "41": "Association",
  "42": "Athletics Association",
  "43": "State",
  "44": "Region",
  "45": "Private School, Religious Affiliation",
  "46": "Program",
  "47": "Company",
  "48": "Federal Government Office",
  "49": "State Government Office",
  "50": "Local Government Office",
  "51": "County Operated School",
  "52": "Department",
  "53": "Career-Trade Education Provider",
  "54": "CMO",
  "55": "County-Superintendent Offices",
  "56": "Organization Substructure Other",
  "99999": "NO MAP"
};



const GRADE_CODE_MAP: IOrderedMap = {
  '': {
    label: "Choose Grade Level",
    order: 0
  },
  '22': {
    label: 'Prekindergarten',
    order: 1
  },
  '23': {
    label: 'Kindergarten',
    order: 2
  },
  '24': {
    label: '1st Grade',
    order: 3
  },
  '25': {
    label: '2nd Grade',
    order: 4
  },
  '26': {
    label: '3rd Grade',
    order: 5
  },
  '27': {
    label: '4th Grade',
    order: 6
  },
  '28': {
    label: '5th Grade',
    order: 7
  },
  '14': {
    label: '6th Grade',
    order: 8
  },
  '15': {
    label: '7th Grade',
    order: 9
  },
  '2': {
    label: '8th Grade',
    order: 10
  },
  '4': {
    label: '9th Grade',
    order: 11
  },
  '5': {
    label: '10th Grade',
    order: 12
  },
  '6': {
    label: '11th Grade',
    order: 13
  },
  '7': {
    label: '12th Grade',
    order: 14
  },
  '29': {
    label: '13th Grade',
    order: 15,
  },
  '10': {
    label: 'No Answer',
    order: 16
  },
};

// Can replace with call to msReference if we get the
// permissions and code for the backend.
export const getK12Codes = (): IStringMap => {
  return K12_TYPE_MAP;
};

export const getOrgCodes = (): IStringMap => {
  return ORG_TYPE_MAP;
};

export const getOrgSubTypeOptions = (): IOptions[] => {
  return Object.keys(ORG_TYPE_MAP).map((key) => ({ label: ORG_TYPE_MAP[key], value: key })).sort((a, b) => a.label > b.label ? 1 : -1);
};

export const getOrgSubTypeLabel = (code: string): string => {
  return ORG_TYPE_MAP[code];
};

export const getGradeName = (code: string): string => {
  const name = GRADE_CODE_MAP[code];
  if (!name) throw new Error(`Cannot locate a mapping for code: ${code}`);
  return name.label;
};

export const getGradeCodes = (): IOrderedMap => {
  return GRADE_CODE_MAP;
};

export const getGradeOptions = (): IOptions[] => {
  const mapped = Object.keys(GRADE_CODE_MAP).map((key) => ({ option: GRADE_CODE_MAP[key], value: key }));
  const sorted = mapped.sort((a, b) => a.option.order - b.option.order);
  return sorted.map((item) => ({ label: item.option.label, value: item.value }));
};

export const getAIStatusCodes = (): IStringMap => {
  return AI_STATUS_MAP;
};

export const getAIStatusOptions = (): IOptions[] => {
  return Object.keys(AI_STATUS_MAP).map((key) => ({ label: AI_STATUS_MAP[key], value: key })).sort((a, b) => a.label > b.label ? 1 : -1);
};

export const isAIActive = (status: string): boolean => {
  return status === AI_STATUS_ACTIVE;
};

export const instLvlOptions: IOptions[] = [
  { value: '1', label: 'Four or more years' },
  { value: '2', label: 'At least two years but less than four years' },
  { value: '3', label: 'Less than 2 years (below associate)' },
  { value: '-3', label: 'N/A' },
];
